<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de grupos de galerías</h1>
    <div class="results" v-if="groups">
      <div class="results__element" v-for="(group, index) in groups" :key="index">
        <div class="results__info">
          <h2 class="results__title" v-text="group.name"></h2>
        </div>
        <div class="results__actions">
          <button @click.prevent="$parent.$emit('view', group.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">Ver Grupo</button>
          <button @click.prevent="$parent.$emit('edit', group.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Grupo</button>
          <button @click.prevent="deleteGroup(group.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Grupo</button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    }
  },
  mixins: [
    httpService
  ],
  components: {confirmation},
  data: function () {
    return {
      groupId: null,
      groups: null,
      confirm: false
    }
  },
  created: function () {
    this.getGroups()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    filters: function () {
      this.getGroups()
    },
    '$store.state.elementChanged': function () {
      this.getGroups()
    }
  },
  methods: {
    getGroups: function () {
      let httpRequest = {
        params: '?' + this.filters,
        module: 'gallery_groups'
      }
      this.get(httpRequest)
        .then(
          groups => {
            this.groups = groups.data
          }
        ).catch(
          () => {
            this.groups = null
          }
        )
    },
    deleteGroup: function (id) {
      this.confirm = true
      this.groupId = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_groups'
      }
      this.delete(this.groupId, httpRequest)
        .then(
          response => {
            this.getGroups()
            this.$store.commit('notificate', {
              title: 'GRUPO BORRADO',
              text: 'El grupo de galerías ha sido borrado correctamente',
              type: 'success'
            })
          }
        ).catch (
          error => {
            this.$store.commit('notificate', {
              title: 'GRUPO NO BORRADO',
              text: 'No se pudo borrar el grupo de galerías seleccionado, por favor intente más tarde',
              type: 'warn'
            })
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery_groups/list.vue